import { useNavigate } from 'react-router-dom';
import { UsersRound } from 'lucide-react';
import { useToast } from '@vnetwork/ui/feedback';
import { useCreateIamGroup, s3ExtractError } from '@/api/s3';
import { IamNameCreateForm } from '../IamNameCreateForm';

/** Create an IAM group — name only, validated client-side. */
export function GroupCreate({ serviceId }: { serviceId: string }) {
  const navigate = useNavigate();
  const toast = useToast();
  const create = useCreateIamGroup(serviceId);
  const listPath = `/services/oss/${serviceId}/iam/groups`;

  return (
    <IamNameCreateForm
      title="Create group"
      description="Add an IAM group to this storage service."
      label="Group name"
      placeholder="e.g. content-editors"
      icon={<UsersRound size={22} />}
      submitLabel="Create group"
      pending={create.isPending}
      onCancel={() => navigate(listPath)}
      onSubmit={(name) =>
        create.mutate(name, {
          onSuccess: () => {
            toast.success('Group created');
            navigate(listPath);
          },
          onError: (e) => toast.error(s3ExtractError(e, 'Failed to create group')),
        })
      }
    />
  );
}
